import { createSelector } from 'reselect';

import * as Store from 'store';

import * as Types from './types';

export const getList = createSelector<Store.Types.IState, Types.IEntity.Act[], Types.IEntity.Act[]>(
  (state => state.act.list.items),
  (items) => items
);